import { Grid, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import IframeLoader from './IframeLoader'
import { useToolBuilder } from 'containers/ToolBuilder/Hook'
import { useAppSelector } from 'redux/Hook'

function Preview({ livePreviewWidth }: { livePreviewWidth: string }) {
  const { t } = useTranslation()
  const { isMd, toolId, toolType } = useToolBuilder()
  const { id } = useAppSelector((state) => state.toolBuilder.toolBuilder)
  const isToolIdPresent = toolId ?? id

  if (isMd) return null

  return (
    <Grid
      item
      md={8}
      xs={12}
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      {!isToolIdPresent || !toolType ? (
        <Typography align="center">
          {t('toolBuilder.noPreviewToDisplay')}
        </Typography>
      ) : (
        <IframeLoader livePreviewWidth={livePreviewWidth} />
      )}
    </Grid>
  )
}

export default Preview
